import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import axios from "axios";

export default {

	async getAccessTokenDataAzureAd({ url, queryString }) {
		return (await axios.post(url, queryString, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded;charset=utf-8;"
			}
		})).data;
	},

	async authenticateAzureAd({strategy, tenantId, accessToken}) {
		return BifrostBackendNestApi.post(`/authentication/azure-ad`, {
			strategy,
			tenantId
		}, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
		});
	},

	async authenticateGoogle({ queryData, tenantId, callbackUrl }) {
		return BifrostBackendNestApi.get(
			`authentication/google`, {
				params: {
					...queryData,
					tenantId,
					callbackUrl
				}
			});
	},

	async jwt1ToJwt2({ accessToken }) {
		return BifrostBackendNestApi.get(
			`authentication/jwt1ToJwt2`, {
				headers: {
					Authorization: `${accessToken}`
				}
			});
	}
};
